import { render, staticRenderFns } from "./LegalPersonsDetails.vue?vue&type=template&id=2b32d5a0&scoped=true&"
import script from "./LegalPersonsDetails.vue?vue&type=script&lang=js&"
export * from "./LegalPersonsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32d5a0",
  null
  
)

export default component.exports